import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-existing-personnel',
  templateUrl: './existing-personnel.component.html',
  styleUrls: ['./existing-personnel.component.css']
})
export class ExistingPersonnelComponent implements OnInit {
  title="Personnel Information";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/personnel-details/Personnels/existing-personnel/existing-personnel.component.ts